module.exports = __webpack_public_path__ + "static/media/Freeconsult.e2989709.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner/Freeconsult.svg
// module id = 77
// module chunks = 0